import { useFormikContext } from 'formik';
import { ReleaseIdCard } from 'front-office/view-models/release-id-card';
import ProfessionTitleForm from 'shell/components/shared/profession-title-form';
import { AccordionProfessionTitle } from 'shell/view-models/accordion-profession-title';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import ProfessionDescriptionAutoList from './profession-description-autocomplete';

const OtherDataForm = (): React.ReactElement => {
  const formContext = useFormikContext<ReleaseIdCard>();

  const [open, setOpen] = useState(false);

  const onChange = useEventCallback(
    (
      key: keyof AccordionProfessionTitle,
      value: AccordionProfessionTitle[keyof AccordionProfessionTitle]
    ) => {
      const newOtherData = {
        ...formContext.values.otherData,
        [key]: value,
      };

      formContext.setFieldValue('otherData', newOtherData);
    }
  );

  const onChangeValues = useEventCallback((values: AccordionProfessionTitle) => {
    const newOtherData = {
      ...formContext.values.otherData,
      ...values,
    };

    formContext.setFieldValue('otherData', newOtherData);
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-content"
        id="panel-person-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Professione/Titolo di studio</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ProfessionTitleForm
          values={formContext.values.otherData as AccordionProfessionTitle}
          onChange={onChange}
          onChangeValues={onChangeValues}
          isEditMode
        >
          <ProfessionDescriptionAutoList
            value={formContext.values.otherData?.professionDescription}
            onChange={(value) => onChange('professionDescription', value)}
            gender={formContext.values.dati3002?.generalita?.sesso}
          />
        </ProfessionTitleForm>
      </AccordionDetails>
    </Accordion>
  );
};

OtherDataForm.displayName = 'Release id card form - other data component';

export default OtherDataForm;
